<template>
  <div class="suggestions">
    <el-tabs>
      <el-tab-pane label="New data" class="records">
        <headers></headers>
        <rows></rows>
      </el-tab-pane>
      <el-tab-pane label="Admin suggestions">
        <suggested></suggested>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style scoped>
.suggestions {
  height: 100%;
  display: flex;
}

.suggestions >>> .el-tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.suggestions >>> .el-tabs__header {
  flex: 0 0 auto;
  margin: 20px;
}

.suggestions >>> .el-tabs__content {
  flex: 1 1 auto;
}

.records {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>

<script>

import Headers from './Headers'
import Rows from './Rows'
import Suggested from './Suggested'

export default {
  components: {
    Headers,
    Rows,
    Suggested
  }
}
</script>



// WEBPACK FOOTER //
// src/components/suggestions/Suggestions.vue